import { Scene, _ } from "~/route/globals";
import { ROUTE_CONST } from "~/route/const";
import { store } from "~/state/store";
import { watch, watchMapset } from "~/state/util";
import { Unsubscribe } from "redux";
import { setMapset } from "~/state/map/state";
import { icon, node } from "~/util/dom";

export default class Info {
	_storeUnsubscribe: Unsubscribe;

	_container: HTMLDivElement;

	_lids: Array<any>;

	_providerListener: any;

	constructor() {
		this._container = node("div", { className: "route-info" });
		this._lids = [];
		this._providerListener = null;

		this._setListeners();
	}

	destroy() {
		this._container.remove();
		Scene.removeListeners(this._providerListener);
		Mapy.CML.removeListeners(this._lids);
	}

	get container() {
		return this._container;
	}

	/**
	 * Nastaveni posluchacu.
	 */
	_setListeners() {
		this._lids.push(Mapy.CML.addListener((responseData, state) => {
			this._showInfo(responseData, state.route.params);
		}, "route.responseData"));

		this._lids.push(Mapy.CML.addListener((error, state) => {
			this._showInfo([], state.route.params, true);
		}, "route.error"));

		this._lids.push(Mapy.CML.addListener((params, state) => {
			this._showInfo(state.route.responseData, params);
		}, "route.params"));

		const wt = watch(store.getState, "map", watchMapset);

		this._storeUnsubscribe = store.subscribe(wt(() => {
			if (Mapy.getComponent("route").isActive()) {
				const routeState = Mapy.CML.state.route;

				this._showInfo(routeState.responseData, routeState.params);
			}
		}));

		this._providerListener = Scene.addListener("provider-changed", () => {
			const routeState = Mapy.CML.state.route;

			this._showInfo(routeState.responseData, routeState.params);
		});
	}

	_showInfo(responseData, params, error?) {
		this._container.innerHTML = "";

		if (!responseData.length && !error) {
			// auto a dopravni mapa neni aktivni a nejsme ve 3D
			if (params.type === ROUTE_CONST.TYPE_CAR) {
				const pInfo = node("p", { innerHTML: _("route.car.tip") });

				pInfo.addEventListener("click", event => {
					if ((event.target as HTMLElement).tagName.toLowerCase() === "button") {
						if (Scene.isM3dActive()) {
							Scene.setActive("map").then(() => {
								store.dispatch(setMapset({ mapset: "dopravni" }));
								Mapy.getComponent("history").save(true);
							}, () => {});
						} else {
							store.dispatch(setMapset({ mapset: "dopravni" }));
							Mapy.getComponent("history").save(true);
						}
						Mapy.getComponent("logger").log("click", {
							text: "route_empty_traffic",
						});
					}
				});
				this._container.appendChild(icon("traffic"));
				this._container.appendChild(pInfo);
			}

			// MHD
			if (params.type === ROUTE_CONST.TYPE_PUBT) {
				const pInfo = node("p", { innerHTML: _("route.pubt.tip") });

				this._container.appendChild(icon("pubt"));
				this._container.appendChild(pInfo);
			}

			// cyklista a neni aktivni turisticky mapset
			if (params.type === ROUTE_CONST.TYPE_BIKE) {
				const pInfo = node("p", { innerHTML: _("route.bike.tip") });

				pInfo.addEventListener("click", event => {
					if ((event.target as HTMLElement).tagName.toLowerCase() === "button") {
						if (Scene.isM3dActive()) {
							Scene.setActive("map").then(() => {
								store.dispatch(setMapset({ mapset: "turisticka" }));
								Mapy.getComponent("history").save(true);
							}, () => {});
						} else {
							store.dispatch(setMapset({ mapset: "turisticka" }));
							Mapy.getComponent("history").save(true);
						}
						Mapy.getComponent("logger").log("click", {
							text: "route_empty_bike",
						});
					}
				});
				this._container.appendChild(icon("bike"));
				this._container.appendChild(pInfo);
			}

			// pesak, kdyz jeste neni 3D aktivni
			if (params.type === ROUTE_CONST.TYPE_WALK) {
				const pInfo = node("p", { innerHTML: _("route.walk.tip") });

				pInfo.addEventListener("click", event => {
					if ((event.target as HTMLElement).tagName.toLowerCase() === "button") {
						if (!Scene.isM3dActive()) {
							Scene.setActive("m3d");
							Mapy.getComponent("logger").log("click", {
								text: "route_empty_walk",
							});
							Mapy.getComponent("history").save(true);
						}
					}
				});
				this._container.appendChild(icon("walk"));
				this._container.appendChild(pInfo);
			}

			// bezky a neni aktivni zimni mapa
			if (params.type === ROUTE_CONST.TYPE_SKI) {
				const pInfo = node("p", { innerHTML: _("route.ski.tip") });

				pInfo.addEventListener("click", event => {
					if ((event.target as HTMLElement).tagName.toLowerCase() === "button") {
						if (Scene.isM3dActive()) {
							Scene.setActive("map").then(() => {
								store.dispatch(setMapset({ mapset: "zimni" }));
								Mapy.getComponent("history").save(true);
							}, () => {});
						} else {
							store.dispatch(setMapset({ mapset: "zimni" }));
							Mapy.getComponent("history").save(true);
						}
						Mapy.getComponent("logger").log("click", {
							text: "route_empty_ski",
						});
					}
				});
				this._container.appendChild(icon("ski"));
				this._container.appendChild(pInfo);
			}

			// lod
			if (params.type === ROUTE_CONST.TYPE_BOAT) {
				const pInfo = node("p", { textContent: _("route.boat.tip") });

				this._container.appendChild(icon("boat"));
				this._container.appendChild(pInfo);
			}
		}
	}
}
